const styles = {
  link: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
};

export default styles;
